module.exports = __webpack_public_path__ + "img/sushi-icon.8f9c9539.svg";